import { render, staticRenderFns } from "./EditorialRankingLog.vue?vue&type=template&id=6a91e298&scoped=true&"
import script from "./EditorialRankingLog.vue?vue&type=script&lang=js&"
export * from "./EditorialRankingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a91e298",
  null
  
)

export default component.exports